import { WageringState } from '../models'

/**
 * SET WC INITIAL STATE
 */
const initialState: WageringState = {
  isLoading: false,
  hasError: false,
  error: '',
  wasDeleted: false,
  wageringCategory: [],
  categoriesList: [],
  gamesList: [],
  currentWageringCategory: null,
  isLoadingGames: false,
  isLoadingCategories: false,
  wageringContributionId: '',
}

export default initialState
